import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default BaseChannelSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    channelObject: {
      embedded: 'always'
    },
    objectMapAcknowledgmentErrors: {
      embedded: 'always'
    },
    objectMapFieldMasks: {
      embedded: 'always'
    }
  },
  modelNameFromPayloadKey() {
    return 'channels/object-map';
  },
  keyForRelationship(key, relationship, ...args) {
    if (key === 'channel') {
      return `${key}_id`;
    }
    return this._super(key, relationship, ...args);
  }
});